import React from 'react';
import MultiIonAnimationSection from '../components/MultiIonAnimationSection';

const AnimationPage = () => {
  return (
    <div className="pt-20">
      <section className="py-16 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Multi-Ion <span className="text-emerald-400">Animation</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Visualize how our Multi-Ion technology works at the molecular level.
          </p>
        </div>
      </section>
      <MultiIonAnimationSection />
    </div>
  );
};

export default AnimationPage;
